import { handleActions } from 'redux-actions';
import { defaultChangeEmailWidgetState } from './defaults';
import { ChangeEmailWidgetData, ChangeEmailWidgetDisplayMode } from './types';
import { initMyAccountPage } from '../../actions';
import {
  INITIAL_SAVE_REQUEST_META,
  makeSpecificSaveableWidgetDataMergeFunction,
  saveableWidgetRequestMetaReducer,
} from '../../widgets/utils';
import {
  setChangeEmailWidgetEmail,
  setChangeEmailWidgetPassword,
  saveChangeEmail,
  saveChangeEmailSuccess,
  saveChangeEmailFailure,
  setChangeEmailWidgetDisplayMode,
  setChangeEmailWidgetOtp,
} from './actions';
import {
  sendOneTimePasswordRequest,
  sendOneTimePasswordRequestFailure,
  sendOneTimePasswordRequestSuccess,
} from '../../../oneTimePassword/actions';

const mergeChangeEmailWidgetDataChange = makeSpecificSaveableWidgetDataMergeFunction(
  defaultChangeEmailWidgetState,
  widgetState => {
    return widgetState.currentData.email !== widgetState.initialData.email;
  }
);

export default handleActions<ChangeEmailWidgetData, any>(
  {
    [initMyAccountPage.toString()]: (state, action: ReturnType<typeof initMyAccountPage>) => {
      const data: ChangeEmailWidgetData['initialData'] = {
        email: action.payload.data.email ?? '',
        password: defaultChangeEmailWidgetState.initialData.password,
      };
      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        canUpdateEmail: action.payload.data.canUpdateEmail,
        saveRequest: INITIAL_SAVE_REQUEST_META,
      };
    },
    [setChangeEmailWidgetEmail.toString()]: (
      state,
      action: ReturnType<typeof setChangeEmailWidgetEmail>
    ) =>
      mergeChangeEmailWidgetDataChange(state, {
        email: action.payload.email,
      }),
    [setChangeEmailWidgetPassword.toString()]: (
      state,
      action: ReturnType<typeof setChangeEmailWidgetPassword>
    ) =>
      mergeChangeEmailWidgetDataChange(state, {
        password: action.payload.password,
      }),
    [setChangeEmailWidgetOtp.toString()]: (
      state,
      action: ReturnType<typeof setChangeEmailWidgetOtp>
    ) =>
      mergeChangeEmailWidgetDataChange(state, {
        otp: action.payload.otp,
      }),
    [setChangeEmailWidgetDisplayMode.toString()]: (
      state,
      action: ReturnType<typeof setChangeEmailWidgetDisplayMode>
    ) => ({
      ...state,
      displayMode: action.payload.displayMode,
    }),

    [sendOneTimePasswordRequest.toString()]: (
      state,
      action: ReturnType<typeof sendOneTimePasswordRequest>
    ) => ({
      ...state,
      displayMode: ChangeEmailWidgetDisplayMode.WaitingForOtp,
    }),
    [sendOneTimePasswordRequestSuccess.toString()]: (
      state,
      action: ReturnType<typeof sendOneTimePasswordRequestSuccess>
    ) => ({
      ...state,
      displayMode: ChangeEmailWidgetDisplayMode.Editing,
    }),
    [sendOneTimePasswordRequestFailure.toString()]: (
      state,
      action: ReturnType<typeof sendOneTimePasswordRequestFailure>
    ) => ({
      ...state,
      displayMode: ChangeEmailWidgetDisplayMode.NotEditing,
    }),
    ...saveableWidgetRequestMetaReducer({
      initialAction: saveChangeEmail,
      successAction: saveChangeEmailSuccess,
      failureAction: saveChangeEmailFailure,
      additionalStateUpdates: {
        successStateUpdate: (state, action) => ({
          displayMode: ChangeEmailWidgetDisplayMode.NotEditing,
        }),
      },
    }),
  },
  defaultChangeEmailWidgetState
);
